<template>
    <div id="app">

        <div v-if="isDataAvailable" class="modal fade" id="planModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <span class="modal-title u-bold h5" id="plan-modal-title">{{ openProduct.plan.name }}</span>
                        <button type="button" class="close" data-dismiss="modal">
                            <span class="sr-only">Close</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <ul
                            v-if="displayMoreCharac && displayMoreCharac.length > 0"
                            class="t-text t-text--small">
                            <li
                                v-for="(charac, index) in displayMoreCharac"
                                :key="charac.sub_information + '-' + index"
                                class="c-plan-card__bullet-point u-marg-b-xxxs">
                                <em
                                    class="c-plan-card__bullet-icon t-icon t-icon--sm t-icon--bg"
                                    :style="`background-image: url(${charac.picto});`"></em>
                                <span>{{ charac.sub_information }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <StickyHeader/>
        <div class="container device-container">

            <div class="row u-marg-t-sm">

                <div class="col-12 col-md-5 js-product-page-gallery" v-if="isDataAvailable">

                    <div
                        v-if="isMobile"
                        class="c-product-page__top-info u-full-width u-marg-b-sm"
                        data-origin-before=".c-product-page__info"
                        data-origin-destination=".c-product-page__info-container"
                        data-destination=".c-product-page__top-container"
                        data-before=".js-product-page-gallery"
                        data-device="mobile">

                        <div class="row u-marg-l-0 u-marg-r-0">
                            <div v-if="productInformations.custom_product_label" class="col-12 u-marg-b-xxs">
                                <span class="t-label t-label--green">{{
                                        productInformations.custom_product_label
                                    }}</span>
                            </div>
                            <div class="col-9">
                                <h1 class="t-h1">
                                    <span class="t-text t-text--small u-grey-text u-bold u-block">{{
                                            productInformations.brand_name
                                        }}</span>
                                    {{ productInformations.name }}
                                </h1>
                            </div>

                            <div class="col-3 c-product-page__top-info-icon">
                                <svg v-if="productInformations.device_compat_5g === '1'"
                                     class="u-marg-l-xxxs t-icon t-icon--lg">
                                    <use xlink:href="#icon-5g"></use>
                                </svg>
                                <svg v-if="productInformations.device_compat_esim === '1'"
                                     class="u-marg-l-xxxs t-icon t-icon--lg">
                                    <use xlink:href="#icon-esim"></use>
                                </svg>
                                <svg v-if="productInformations.device_compat_doublesim === '1'"
                                     class="u-marg-l-xxxs t-icon t-icon--lg">
                                    <use xlink:href="#icon-double-sim"></use>
                                </svg>
                                <svg v-if="productInformations.device_reconditionne === '1'"
                                     class="u-marg-l-xxxs t-icon t-icon--lg">
                                    <use xlink:href="#icon-icon-reconditionne"></use>
                                </svg>
                            </div>
                        </div>
                    </div>

                    <MediaGallery/>

                    <div
                        v-if="productInformations.promotions && productInformations.promotions.length > 0"
                        class="col-12 c-sticker-mobile-slider c-sticker-slider js-sticker-mobile-slider">
                        <!-- We add + 1 to the index to match the naming from backend -->
                        <Sticker
                            v-for="(sticker, index) in productInformations.promotions"
                            :key="'sticker-' + index"
                            :index="index"
                            :img="sticker[`picto_offer`]"
                            :color="sticker[`promo_color`]"
                            :text="sticker[`promo_text`]"
                        />
                    </div>

                    <div
                        v-if="productInformations && productInformations.informational_msg && productInformations.informational_msg.length > 0"
                        class="col-12 c-informational-msg__container">
                        <div
                            class="c-informational-msg"
                            v-html="productInformations.informational_msg"></div>
                    </div>
                </div>

                <!-- PRODUCT INFOS AND CONF -->
                <div class="col-12 col-md-6" v-if="isDataAvailable && isDesktop">
                    <div class="row">
                        <div class="c-product-page__top-info u-full-width" data-origin-before=".c-product-page__info"
                             data-origin-destination=".c-product-page__info-container"
                             data-destination=".c-product-page__top-container" data-before=".js-product-page-gallery"
                             data-device="mobile">
                            <div class="row u-marg-l-0 u-marg-r-0">
                                <div v-if="productInformations.custom_product_label" class="col-12 u-marg-b-xxs">
                                    <span class="t-label t-label--green">{{
                                            productInformations.custom_product_label
                                        }}</span>
                                </div>
                                <div class="col-12 col-lg-6">
                                    <h1 class="t-h1">
                                        <span class="t-text t-text--small u-grey-text u-bold u-block">{{
                                                productInformations.brand_name
                                            }}</span> {{ productInformations.name }}
                                    </h1>
                                </div>

                                <div class="col-12 col-lg-6 c-product-page__top-info-icon">
                                    <svg v-if="productInformations.device_compat_5g === '1'"
                                         class="u-marg-l-xxxs t-icon t-icon--lg">
                                        <use xlink:href="#icon-5g"></use>
                                    </svg>
                                    <svg v-if="productInformations.device_compat_esim === '1'"
                                         class="u-marg-l-xxxs t-icon t-icon--lg">
                                        <use xlink:href="#icon-esim"></use>
                                    </svg>
                                    <svg v-if="productInformations.device_compat_doublesim === '1'"
                                         class="u-marg-l-xxxs t-icon t-icon--lg">
                                        <use xlink:href="#icon-double-sim"></use>
                                    </svg>
                                    <svg v-if="productInformations.device_reconditionne === '1'"
                                         class="u-marg-l-xxxs t-icon t-icon--lg">
                                        <use xlink:href="#icon-icon-reconditionne"></use>
                                    </svg>
                                </div>

                            </div>
                        </div>

                        <ColorSwatch :colors="currentProduct.colorMapping"/>

                        <CapacityList :capacity-list="currentProduct.capacityMapping"/>

                        <ProductStatus :status="currentProduct.color"/>

                        <Plan :is-plan-selected-from-url="isFromUrl"/>

                        <Resume/>

                    </div>
                </div>

            </div>
        </div>
        <div
            v-if="isDataAvailable && isMobile || isDataAvailable && isTablet"
            :class="['container', isTablet ? '' : 'u-bg-grey-300']">
            <div class="row u-pad-t-sm u-pad-b-sm">
                <div class="col-12 u-bg-white u-pad-l-xxs u-pad-r-xxs">
                    <div class="row px-2">

                        <ColorSwatch :colors="currentProduct.colorMapping"/>

                        <CapacityList :capacity-list="currentProduct.capacityMapping"/>

                        <ProductStatus :status="currentProduct.color"/>

                        <Plan :is-plan-selected-from-url="isFromUrl"/>

                        <Resume/>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import store from '~src/store/Devices'
import Plan from '~devices/Plan'
import ColorSwatch from '~devices/ColorSwatch'
import CapacityList from '~devices/CapacityList'
import ProductStatus from '~devices/ProductStatus'
import Resume from '~devices/Resume'
import StickyHeader from '~devices/StickyHeader'
import MediaGallery from '~devices/MediaGallery'
import Sticker from '~devices/Sticker'

import Helpers from '~plugins/Helpers'

import {mapGetters, mapActions, mapMutations} from 'vuex'

export default {
    store,
    name: 'Devices',
    components: {
        ColorSwatch,
        CapacityList,
        Plan,
        ProductStatus,
        Resume,
        StickyHeader,
        MediaGallery,
        Sticker
    },
    props: {
        devicesData: {
            type: Object,
            default: () => {
            }
        },
        traduction: {
            type: Function,
        }
    },
    data() {
        return {
            isFromUrl: false,
            colorMapping: [],
            capacityMapping: [],
            isDataAvailable: false,
            isDesktop: true,
            isMobile: false,
            isTablet: false
        }
    },
    async created() {
        let devicesData = {}

        if (Helpers.isDev()) {
            const data = await import('~data/data-dev-devices.js')
            devicesData = data.default
            this.filterData(devicesData)
            this.isDataAvailable = true
        } else {
            devicesData = {...this.devicesData}
            this.filterData(devicesData)
            this.isDataAvailable = true

            this.setTraduction(this.traduction)
        }
    },
    computed: {
        ...mapGetters({
            productInformations: 'GET_PRODUCT_INFORMATIONS',
            currentProduct: 'GET_CURRENT_PRODUCT',
            openProduct: 'GET_OPEN_PRODUCT',
            addToCartButtonState: 'GET_ADD_TO_CART_BUTTON_STATE'
        }),
        displayMoreCharac() {
            const characteristics = Object.keys(this.openProduct.plan).length ? [...this.openProduct.plan.characteristics] : [...this.currentProduct.plan.characteristics]

            if (characteristics && characteristics.length > 0) {
                // Filter characteristics to include only those of type 'card'
                return characteristics.filter(charac => charac.type === 'card');
            }
        },
    },
    mounted() {
        // When app ready, hide native product informations
        if (document.querySelector('.js-product-seo-info')) {
            document.querySelector('.js-product-seo-info').style.display = 'none';
        }

        this.isDesktop = Helpers.isDesktop()
        this.isMobile = Helpers.isMobile()
        this.isTablet = Helpers.isTablet()

        if (Helpers.isMobile()) {
            this.createStickerSlider();
        }

        if (!Helpers.isProd()) {
            let element = document.createElement("link");
            element.setAttribute("rel", "stylesheet");
            element.setAttribute("type", "text/css");
            element.setAttribute("href", process.env.BASE_URL + 'css/theme.css');
            document.getElementsByTagName("head")[0].appendChild(element);
        }

        this.cloneBreadcrumbs()
    },
    methods: {
        ...mapActions({
            setProductInformations: 'SET_PRODUCT_INFORMATIONS',
            setCurrentProduct: 'SET_CURRENT_PRODUCT'
        }),
        ...mapMutations({
            setTraduction: 'UPDATE_TRADUCTION',
            updateButtonState: 'UPDATE_ADD_TO_CART_BUTTON_STATE',
        }),
        createStickerSlider() {
            // first we set all slider elements to same height
            let stickersItems = document.getElementsByClassName('c-sticker-mobile')
            if (!stickersItems.length) return
            stickersItems = Array.from(stickersItems)
            const heights = stickersItems.map(item => item.offsetHeight);
            const maxHeight = Math.max(...heights);

            stickersItems.forEach(item => {
                item.style.height = `${maxHeight}px`
            });

            const Flickity = window.Flickity
            new Flickity('.js-sticker-mobile-slider', {
                prevNextButtons: false
            })
        },
        /*!
        * Move an item from one index to another in an array.
        * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
        * @param  {Array}   arr  The array to move the item in
        * @param  {Integer} from The starting index of the item
        * @param  {Integer} to   The new index for the item
        */
        moveInArray(arr, from, to) {

            // Make sure a valid array is provided
            if (Object.prototype.toString.call(arr) !== '[object Array]') {
                throw new Error('Please provide a valid array');
            }

            // Delete the item from it's current position
            let item = arr.splice(from, 1);

            // Make sure there's an item to move
            if (!item.length) {
                throw new Error('There is no item in the array at index ' + from);
            }

            // Move the item to its new position
            arr.splice(to, 0, item[0]);

        },
        filterData(devicesData) {
            let infos = devicesData.device

            const devicePlanSkuFromUrl = Helpers.getParamValue('fromPlan');
            const isFromUrl = devicePlanSkuFromUrl ? true : false
            this.isFromUrl = isFromUrl
            const defaultDevicePlanSkuFromMagento = devicesData.default_plan_sku && devicesData.default_plan_sku.length > 0 ? devicesData.default_plan_sku : ''

            let currentIndexColor = 0
            let currentIndexCapacity = 0
            let deviceSku = null

            if (Helpers.getParamValue('capacity') && Helpers.getParamValue('capacity') !== '') {
                const urlSwatch = Helpers.getParamValue('capacity')
                currentIndexCapacity = infos.super_attributes.device_capacity.options.findIndex(capacity => capacity.swatch === urlSwatch)
                // If the capacity is not found or not valid we default to the first capacity
                if (currentIndexCapacity === -1) currentIndexCapacity = 0

                // If the currentIndexCapacity is superior to the length of the color options array it means
                // the capacity is not available in the color selected, to avoid error we default to the first capacity
                if (currentIndexCapacity > infos.super_attributes.color.options[currentIndexColor].products.length + 1) currentIndexCapacity = 0
            }

            if (Helpers.getParamValue('color') && Helpers.getParamValue('color') !== '' && Helpers.isHexValid(Helpers.getParamValue('color'))) {
                const urlSwatch = Helpers.getParamValue('color')

                currentIndexColor = infos.super_attributes.color.options.findIndex(color => color.swatch === `#${urlSwatch}`)
                if (currentIndexColor === -1) currentIndexColor = 0
            }

            let found = false;

            //new

            const ids = ["32GB", "64GB", "128GB", "256GB", "512GB", "1TB", "2TB"];

            let foundSku = null;

                for (const capacity of ids) {
                    for (const sku of infos.skus) {
                        const { capacity_index, is_salable, sku: skuId, colorIndex, capacityIndex } = sku;
                        if (capacity === capacity_index && is_salable) {
                        foundSku = skuId;
                        currentIndexCapacity = capacityIndex;
                        currentIndexColor = colorIndex;
                        break;
                        }
                    }

                if (foundSku) {
                    break;
                }
                }

             console.log("Found SKU:", foundSku);
            //lss
            // for( const index in infos.skus){
            //     if (infos.skus[index].is_salable == true && found == false) {
            //         currentIndexColor = 1;
            //         currentIndexCapacity = 0;
            //         found = true;
            //     }
            // }
            console.log(currentIndexColor);
            console.log(currentIndexCapacity);
            deviceSku = infos.super_attributes.color.options[currentIndexColor].products[currentIndexCapacity].sku


            // select frist cheapest capcity
           // deviceSku = foundSku
           console.log(deviceSku);
            let currentProductFromState = {...this.currentProduct}


            // select frist cheapest capcity
           // currentProductFromState.sku = foundSku
            // By default always take the first sku from the color attribute

            currentProductFromState.sku = deviceSku

            // If we have the device_plan_sku from the URL and device_plan_sku from magento available in the same time
            // we take the device_plan_sku from the URL
            if (devicePlanSkuFromUrl && devicePlanSkuFromUrl.length > 0 && devicePlanSkuFromUrl.includes('?')) {
                // if we come from a plan sometimes we have "SKU?configurator=true" in this case we select everything before the "?"
                const regex = /^[^\?]+/g
                const matchOnlySku = devicePlanSkuFromUrl.match(regex)
                currentProductFromState.device_plan_sku = matchOnlySku[0]
            } else {
                currentProductFromState.device_plan_sku = devicePlanSkuFromUrl && devicePlanSkuFromUrl.length > 0 ? devicePlanSkuFromUrl : defaultDevicePlanSkuFromMagento
            }

            for (let instalment in infos.instalments) {
                if (instalment === deviceSku) {
                    if (currentProductFromState.device_plan_sku && currentProductFromState.device_plan_sku.length > 0) {
                        currentProductFromState.instalment = infos.instalments[instalment].items.find(instalment => instalment.device_plan_sku === currentProductFromState.device_plan_sku)
                    } else {
                        currentProductFromState.instalment = infos.instalments[instalment].items[0]
                    }
                }
            }

            // if the plan is not available from magento instead of break everything
            // we take the first plan wich is mobile alone
            if (typeof currentProductFromState.instalment === 'undefined') {
                for (let instalment in infos.instalments) {
                    if (instalment === deviceSku) {
                        currentProductFromState.instalment = infos.instalments[instalment].items[0]
                    }
                }
            }

            let plans = []

            for (let plan in infos.plans) {
                if (plan === deviceSku) {
                    plans = infos.plans[plan]
                }
            }

            /*******************************
             * Take the first plan sended by magento
             * replace it by the default device_plan_sku
             * from the URL or selected by default in the admin
             *
             * If there is no match we don't make any modification to the array
             *
             * If there is no match but a global device_plan_sku (refer to defaultDevicePlanSkuFromMagento )is set it means
             * there is something missing in the import so we make sure the device_plan_sku is set to nothing
             * to match the phone only
             ********************************/
            let newPlans = [...plans]
            let availablePlans = [...plans]

            const findPlanIndex = availablePlans.findIndex(plan => plan.sku && plan.sku.length > 0 && plan.sku === currentProductFromState.device_plan_sku)

            if (findPlanIndex > 0) {
                // this.moveInArray(newPlans, findPlanIndex, 0)
            } else {
                currentProductFromState.device_plan_sku = ''
            }

            currentProductFromState.currency = infos.prices[deviceSku].currency

            currentProductFromState.availablePlans = newPlans

            currentProductFromState.plan = newPlans[0]

            currentProductFromState.colorMapping = infos.super_attributes.color.options

            currentProductFromState.capacityMapping = infos.super_attributes.color.options[currentIndexColor].capacities

            this.setCurrentProduct({currentProduct: currentProductFromState})

            this.setProductInformations(infos)

            let productSku = document.querySelector('.product-info-stock-sku .value');
            console.log('productSku', productSku);

            if (null !== productSku && undefined !== productSku) {
                productSku.textContent = deviceSku;
            }
        },
        cloneBreadcrumbs() {
            // get native Magento breadcrumbs
            let breadcrumbs = document.getElementsByClassName('breadcrumbs')[0]
            // true means clone all childNodes and all event handlers
            let breadcrumbs_clone = breadcrumbs.cloneNode(true)
            breadcrumbs_clone.id = "breadcrumbsClone"
            // clone it and inject it into the app
            document.getElementById('app').querySelector('.device-container').prepend(breadcrumbs_clone)
        }
    }
}
</script>
